import React, { FC, useEffect, useState } from "react";

import { LOCAL_STORAGE_KEYS } from "../../common/consts";
import { getHubSpotAuthUrl } from "../../services/firebase";

/**
 * One-click reconnect, linked from customer emails. The page sits under /app,
 * so the visitor signs in first if needed; it then sends the whole tab to
 * HubSpot's install screen. HubSpot returns to /oauth/hubspot, which stores the
 * code, and the dashboard validates it exactly as a first connect does.
 */
const ReconnectHubSpot: FC = () => {
  const [error, setError] = useState("");

  useEffect(() => {
    const go = async () => {
      try {
        const redirectUri = `${window.location.origin}/oauth/hubspot`;
        // Stored as a plain string, the way HubSpotRedirect reads it back.
        localStorage.setItem(LOCAL_STORAGE_KEYS.hubspotRedirectUri, JSON.stringify(redirectUri));
        const { result, status } = await getHubSpotAuthUrl(redirectUri);
        if (status === 200 && result?.hubspotAuthUrl) {
          window.location.href = result.hubspotAuthUrl;
          return;
        }
        setError("Could not open HubSpot. Please try again, or reply to the email and we'll help.");
      } catch {
        setError("Could not open HubSpot. Please try again, or reply to the email and we'll help.");
      }
    };
    go();
  }, []);

  return (
    <div className="d-flex h-100 align-items-center justify-content-center m-auto">
      <p>{error || "Opening HubSpot…"}</p>
    </div>
  );
};

export default ReconnectHubSpot;
